module.exports = __webpack_public_path__ + "79c44fbfaf371ac933d8428ad2498fb6.png";